import styles from '@components/BreadCrumbs.module.css';

import * as React from 'react';
import * as Utilities from '@common/utilities';

interface BreadCrumbsItem {
  url?: string;
  name: string;
}

export interface BreadCrumbsProps {
  style?: React.CSSProperties;
  className?: string;
  items: BreadCrumbsItem[];
}

const BreadCrumbs: React.FC<BreadCrumbsProps> = ({ style, className, items }) => {
  return (
    <nav aria-label="breadcrumb" className={Utilities.classNames(styles.root, className)} style={style}>
      {items.map((item, index) => {
        const linkElement = (
          <a className={styles.link} href={item.url} target="_blank" tabIndex={0} role="link">
            {item.name}
          </a>
        );

        return (
          <span className={styles.line} key={index}>
            {index === items.length - 1 ? <span>{linkElement}</span> : linkElement}
            {index < items.length - 1 && <span className={styles.symbol}> ❯ </span>}
          </span>
        );
      })}
    </nav>
  );
};

export default BreadCrumbs;
